import { combineReducers } from "redux";

import farm from "./farms";
import current_farm from './farm'

export default combineReducers({
  farm, 
  current_farm
});
